import Cookies from 'js-cookie'

import { SUPPORTED_LOCALES, type Locale, type MotionPreference } from '@/types/site'

const LOCALE_COOKIE = 'prodamac_locale'
const MOTION_COOKIE = 'prodamac_motion'

export function getLocalePreference(): Locale | null {
  const value = Cookies.get(LOCALE_COOKIE)
  return SUPPORTED_LOCALES.includes(value as Locale) ? (value as Locale) : null
}

export function setLocalePreference(locale: Locale) {
  Cookies.set(LOCALE_COOKIE, locale, { expires: 365 })
}

export function getMotionPreference(): MotionPreference {
  const value = Cookies.get(MOTION_COOKIE)
  return value === 'reduce' ? 'reduce' : 'system'
}

export function setMotionPreference(value: MotionPreference) {
  Cookies.set(MOTION_COOKIE, value, { expires: 365 })
}

export function getAuthCookieName() {
  return import.meta.env.VITE_AUTH_COOKIE_NAME || 'prodamac_session'
}

export function getFallbackLocale() {
  return getLocalePreference() ?? 'en'
}
